


















declare var window: any;
import { Component, Vue } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { vxm } from './../store.vuex';

@Component({
  name: 'Loader',
  components: {
    Loading,
  },
})
export default class Loader extends Vue {
  private isLoading: boolean = false;
  private fullPage: boolean = true;

  get SpinnerStatus(): boolean {
    return vxm.utility.spinnerStatus;
  }

  get SpinnerColor(): string {
    return vxm.utility.SpinnerColor;
  }

  get SpinnerHeight(): number {
    return vxm.utility.SpinnerHeight;
  }

  get SpinnerWidth(): number {
    return vxm.utility.SpinnerWidth;
  }

  get SpinnerLogo(): string {
    return vxm.configs.getGlobalConfigValue('CANDIDATE_PORTAL_LOGO_SPINER_URL')
  }
  onCancel() {
    console.log('User cancelled the loader.');
  }
}
